import { Stack, Tag, colors } from "@biblioteksentralen/react";
import { Publication } from "@libry-content/types";

interface Props {
  publication: Publication;
}

// TODO: Mark the tags section with lang attribute when in a different language
// Prerequisite: languages on subjects and genres - https://github.com/biblioteksentralen/libry-content/issues/1265
const SubjectTags = ({ publication }: Props) => {
  if (!publication.genre && !publication.subject) return null;

  const { genre, subject } = publication;
  const items = [...(genre?.split(",") ?? []), ...(subject?.split(",") ?? [])];

  return (
    <Stack direction="row" paddingBottom={4} wrap="wrap" justifyContent="flex-start" gap=".5rem">
      {items.length &&
        items.map((item, index) => (
          <Tag.Root
            size="md"
            key={index}
            borderRadius="xl"
            variant="solid"
            color={colors.black}
            bg={colors.white}
            marginInlineStart="0 !important"
          >
            <Tag.Label>{item}</Tag.Label>
          </Tag.Root>
        ))}
    </Stack>
  );
};

export default SubjectTags;
